


























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'interactive-rating',
})
export default class InteractiveRating extends Vue {
  // Props
  @Prop() private msg!: string;

  // State Variables
  private savedOption = 100;

  // Getters and Setters
  get SavedOption(): number {
    return this.savedOption;
  }

  set SavedOption(value: number) {
    this.savedOption = value;
  }

  // Methods
  private handleClick(option: number): void {
    this.SavedOption = option;
  }

  private handleSubmit(): void {
    if (this.SavedOption !== 100) {
      this.$emit('ratingValue', this.SavedOption);
    } else {
      alert("You didn't select any rating!");
    }
  }
}
